import PropTypes from 'prop-types';

const JiraProject = {
  id: PropTypes.number,
  key: PropTypes.string,
  name: PropTypes.string,
};

export default JiraProject;
